/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a new comparison. 
 * Either both estimate IDs or both document IDs must be provided.
 * - Estimate-based: Provide insurerEstimateId and contractorEstimateId
 * - Document-based: Provide insurerDocumentId and contractorDocumentId (extraction will be triggered automatically)
 * 
 * @export
 * @interface CreateComparisonRequest
 */
export interface CreateComparisonRequest {
    /**
     * ID of the claim containing both estimates/documents
     * @type {number}
     * @memberof CreateComparisonRequest
     */
    claimId: number;
    /**
     * ID of the insurer estimate to compare (for estimate-based flow)
     * @type {number}
     * @memberof CreateComparisonRequest
     */
    insurerEstimateId?: number;
    /**
     * ID of the contractor estimate to compare (for estimate-based flow)
     * @type {number}
     * @memberof CreateComparisonRequest
     */
    contractorEstimateId?: number;
    /**
     * ID of the insurer document (for document-based flow - extraction will be triggered)
     * @type {number}
     * @memberof CreateComparisonRequest
     */
    insurerDocumentId?: number;
    /**
     * ID of the contractor document (for document-based flow - extraction will be triggered)
     * @type {number}
     * @memberof CreateComparisonRequest
     */
    contractorDocumentId?: number;
}

/**
 * Check if a given object implements the CreateComparisonRequest interface.
 */
export function instanceOfCreateComparisonRequest(value: object): value is CreateComparisonRequest {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    return true;
}

export function CreateComparisonRequestFromJSON(json: any): CreateComparisonRequest {
    return CreateComparisonRequestFromJSONTyped(json, false);
}

export function CreateComparisonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateComparisonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'insurerEstimateId': json['insurerEstimateId'] == null ? undefined : json['insurerEstimateId'],
        'contractorEstimateId': json['contractorEstimateId'] == null ? undefined : json['contractorEstimateId'],
        'insurerDocumentId': json['insurerDocumentId'] == null ? undefined : json['insurerDocumentId'],
        'contractorDocumentId': json['contractorDocumentId'] == null ? undefined : json['contractorDocumentId'],
    };
}

export function CreateComparisonRequestToJSON(json: any): CreateComparisonRequest {
    return CreateComparisonRequestToJSONTyped(json, false);
}

export function CreateComparisonRequestToJSONTyped(value?: CreateComparisonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'insurerEstimateId': value['insurerEstimateId'],
        'contractorEstimateId': value['contractorEstimateId'],
        'insurerDocumentId': value['insurerDocumentId'],
        'contractorDocumentId': value['contractorDocumentId'],
    };
}

